/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_codon_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A sequence of ATG repeats shows ATG (Met) at a fraction of 1.00.`)
};

const es_codon_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una secuencia de repeticiones de ATG muestra ATG (Met) con una fracción de 1.00.`)
};

const de_codon_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Sequenz von ATG-Wiederholungen zeigt ATG (Met) mit einem Anteil von 1,00.`)
};

const nl_codon_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een sequentie van herhaalde ATG toont ATG (Met) met een fractie van 1,00.`)
};

const fr_codon_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une séquence de répétitions ATG montre ATG (Met) avec une fraction de 1,00.`)
};

const it_codon_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una sequenza di ripetizioni ATG mostra ATG (Met) con una frazione di 1,00.`)
};

const pt_br2_codon_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma sequência de repetições ATG mostra ATG (Met) com fração 1,00.`)
};

const pt_codon_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma sequência de repetições ATG mostra ATG (Met) com uma fração de 1,00.`)
};

const ja_codon_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATGの繰り返し配列では、ATG（Met）の割合が1.00になります。`)
};

const zh_codon_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部由 ATG 重复组成的序列显示 ATG（Met）的比例为 1.00。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const codon_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.codon_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("codon_ex1", locale)
	if (locale === "en") return en_codon_ex1(inputs)
	if (locale === "es") return es_codon_ex1(inputs)
	if (locale === "de") return de_codon_ex1(inputs)
	if (locale === "nl") return nl_codon_ex1(inputs)
	if (locale === "fr") return fr_codon_ex1(inputs)
	if (locale === "it") return it_codon_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_codon_ex1(inputs)
	if (locale === "pt") return pt_codon_ex1(inputs)
	if (locale === "ja") return ja_codon_ex1(inputs)
	return zh_codon_ex1(inputs)
};